module.exports = __webpack_public_path__ + "img/gallery-1.fc4cb08b.jpg";